import { message } from 'antd';
import { call, put, takeEvery, all, fork, takeLatest } from 'redux-saga/effects'

import { getAllHL7SentMessages, resendHL7SentMessageAPI, searchHL7SentMessages } from "../../../services/hl7-sent-message-service";
import { CLOSE_ACKNOWLEDGEMENT_MODAL, FETCH_HL7_SENT_MESSAGES, FETCH_HL7_SENT_MESSAGES_ERROR, FETCH_HL7_SENT_MESSAGES_START, FETCH_HL7_SENT_MESSAGES_SUCCESS, RESEND_HL7_SENT_MESSAGE, RESEND_HL7_SENT_MESSAGE_ERROR, RESEND_HL7_SENT_MESSAGE_START, RESEND_HL7_SENT_MESSAGE_SUCCESS, SEARCH_HL7_SENT_MESSAGES, SEARCH_HL7_SENT_MESSAGES_ERROR, SEARCH_HL7_SENT_MESSAGES_START, SEARCH_HL7_SENT_MESSAGES_SUCCESS } from "../../actions/admin/hl7SentMessagesAction";


function* fetchHL7HL7SentMessages({ payload }) {
    try {
        const { startDate, endDate } = payload;
        yield put({ type: FETCH_HL7_SENT_MESSAGES_START })
        // const response = yield call(getAllHL7OutMessages, endDate, startDate);
        const response = yield call(getAllHL7SentMessages, payload);
        if (response.success) {
            const data = {
                pagination: {
                    currentPage: payload.page,
                    pageSize: payload.size,
                    totalPages: response.data.totalPages,
                    totalItems: response.data.totalItems,
                },
                hl7SentMessages: response.data.messageList ? [...response.data.messageList] : []
            }
            yield put({ type: FETCH_HL7_SENT_MESSAGES_SUCCESS, data })
        } else {
            yield put({ type: FETCH_HL7_SENT_MESSAGES_ERROR, error: response.error })
            message.error('Failed to fetch HL7 sent messages');
        }
    } catch (error) {
        yield put({ type: FETCH_HL7_SENT_MESSAGES_ERROR, error })
        message.error('Failed to fetch HL7 sent messages');
    }
}

function* resendHL7SentMessage({ id }) {
    try {
        yield put({ type: RESEND_HL7_SENT_MESSAGE_START })
        const response = yield call(resendHL7SentMessageAPI, id);
        if (response.success) {
            yield put({ type: RESEND_HL7_SENT_MESSAGE_SUCCESS, data: { ...response } })
            yield put({ type: CLOSE_ACKNOWLEDGEMENT_MODAL });
        } else {
            yield put({ type: RESEND_HL7_SENT_MESSAGE_ERROR, error: response.error })
            message.error('Failed to resend HL7 sent message!');
        }
    } catch (error) {
        yield put({ type: RESEND_HL7_SENT_MESSAGE_ERROR, error })
        message.error('Failed to resend HL7 sent message!');
    }
}

function* searchHL7HL7SentMessages({ payload }) {
    try {
        const { startDate, endDate, messageInterface, mipName, risCode, status } = payload;
        yield put({ type: SEARCH_HL7_SENT_MESSAGES_START })
        // const response = yield call(getAllHL7OutMessages, endDate, startDate);
        const response = yield call(searchHL7SentMessages, payload);
        if (response.success) {
            const data = {
                pagination: {
                    currentPage: payload.page,
                    pageSize: payload.size,
                    totalPages: response.data.totalPages,
                    totalItems: response.data.totalItems,
                },
                searchhl7SentMessages: response.data.messageList ? [...response.data.messageList] : []
            }

            yield put({ type: SEARCH_HL7_SENT_MESSAGES_SUCCESS, data })
        } else {
            yield put({ type: SEARCH_HL7_SENT_MESSAGES_ERROR, error: response.error })
            message.error('Failed to fetch HL7 sent messages!');
        }
    } catch (error) {
        yield put({ type: SEARCH_HL7_SENT_MESSAGES_ERROR, error })
        message.error('Failed to fetch HL7 sent messages!');
    }
}

function* hl7SentMessagesWatcher() {
    yield takeLatest(FETCH_HL7_SENT_MESSAGES, fetchHL7HL7SentMessages)
    yield takeLatest(RESEND_HL7_SENT_MESSAGE, resendHL7SentMessage)
    yield takeLatest(SEARCH_HL7_SENT_MESSAGES, searchHL7HL7SentMessages)
}

export default function* rootSaga() {
    yield all([
        hl7SentMessagesWatcher()
    ]);
}